import { QueryKey, useQuery } from "@tanstack/react-query";

import { TINA_POLL_INTERVAL_MS } from "@/lib/tina/constants";

interface UseTinaPollOptions<T> {
  enabled?: boolean;
  intervalMs?: number;
  shouldPoll?: (data: T | undefined) => boolean;
}

export function useTinaPoll<T>(
  queryKey: QueryKey,
  fetcher: () => Promise<T>,
  {
    enabled = true,
    intervalMs = TINA_POLL_INTERVAL_MS,
    shouldPoll,
  }: UseTinaPollOptions<T> = {},
) {
  return useQuery<T>({
    queryKey,
    queryFn: fetcher,
    enabled,
    refetchInterval: enabled
      ? (query) =>
          shouldPoll && !shouldPoll(query.state.data) ? false : intervalMs
      : false,
    refetchIntervalInBackground: false,
  });
}
